var map = {
	"./dinesh-singh.webp": 2037,
	"./elcano-wilson.webp": 8957,
	"./fazlin-ally.webp": 97,
	"./jose-romero.webp": 4684,
	"./lerene.webp": 5091,
	"./muhammed-daya.webp": 6092,
	"./richard-brews.webp": 4547,
	"./salome-kgoale.webp": 8923,
	"./sean-forrester.webp": 5104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5179;